import { render, staticRenderFns } from "./EmptyContent.vue?vue&type=template&id=7c858b40"
import script from "./EmptyContent.vue?vue&type=script&lang=js"
export * from "./EmptyContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports